export default "__VITE_ASSET__BfLtMe0z__"